
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/usersList';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n\n  <table class=\"roster ic-Table ic-Table--hover-row ic-Table--condensed ic-Table--striped\">\n    <thead>\n      <tr>\n        <th><span class='screenreader-only'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.users_list")
  },data:data},helper ? helper.call(depth0, "avatar_8a8aa935", "Avatar", options) : helperMissing.call(depth0, "t", "avatar_8a8aa935", "Avatar", options)))
    + "</span></th>\n        <th>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.users_list")
  },data:data},helper ? helper.call(depth0, "accounts.users_list.name", "Name", options) : helperMissing.call(depth0, "t", "accounts.users_list.name", "Name", options)))
    + "</th>\n        <th>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.users_list")
  },data:data},helper ? helper.call(depth0, "accounts.users_list.login_name_or_sis_id", "Login / SIS ID", options) : helperMissing.call(depth0, "t", "accounts.users_list.login_name_or_sis_id", "Login / SIS ID", options)))
    + "</th>\n      </tr>\n    </thead>\n    <tbody class=\"collectionViewItems\"></tbody>\n  </table>\n<div class=\"paginatedLoadingIndicator\"></div>\n\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.atLeastOnePageFetched), {hash:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div class=\"alert alert-info\">\n    <p class=\"lead\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.users_list")
  },data:data},helper ? helper.call(depth0, "accounts.users_list.no_people_found", "No people found", options) : helperMissing.call(depth0, "t", "accounts.users_list.no_people_found", "No people found", options)))
    + "</p>\n    <p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.users_list")
  },data:data},helper ? helper.call(depth0, "accounts.users_list.you_can_search_by", "You can search by:", options) : helperMissing.call(depth0, "t", "accounts.users_list.you_can_search_by", "You can search by:", options)))
    + "</p>\n    <ul>\n      <li>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.users_list")
  },data:data},helper ? helper.call(depth0, "accounts.users_list.name", "Name", options) : helperMissing.call(depth0, "t", "accounts.users_list.name", "Name", options)))
    + "</li>\n      <li>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.users_list")
  },data:data},helper ? helper.call(depth0, "accounts.users_list.login_name_or_sis_id", "Login / SIS ID", options) : helperMissing.call(depth0, "t", "accounts.users_list.login_name_or_sis_id", "Login / SIS ID", options)))
    + "</li>\n    </ul>\n  </div>\n  ";
  return buffer;
  }

function program6(depth0,data) {
  
  
  return "\n  <div class=\"paginatedLoadingIndicator\"></div>\n  ";
  }

  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n<div id=\"generate_activity_for_user_mount_point\"></div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  